import React from "react";
import "./index.css";
import "src/lang/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import ReactDOM from 'react-dom';
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@mui/styles";
import { theme } from "./theme";
const container = document.getElementById("root");


function noop() {
}

if (process.env.NODE_ENV !== "development") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

declare global {
  interface Window {
    ReactNativeWebView?: any;
    config?: any;
    flutter_inappwebview?: any;
    interval?: any;
  }
}

window.ReactNativeWebView = window.ReactNativeWebView || null;

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  container
);
reportWebVitals();
